import type { IScreenService } from "App/Modules/Services";

export default class ProfileAddToHomescreenComponentController {
    public static $inject = ["irScreenService"];

    constructor(private screenService: IScreenService) {}
}
